import {
  createSlice,
  createEntityAdapter,
  PayloadAction,
  EntityId,
} from "@reduxjs/toolkit";
import { RootState } from "../../store";
import { Notification } from "./notificationsAPI";
import { v4 as uuid } from "uuid";

const notificationsAdapter = createEntityAdapter<Notification>();

interface InitialState
  extends ReturnType<typeof notificationsAdapter.getInitialState> {}

const initialState: InitialState = {
  ...notificationsAdapter.getInitialState(),
};

const notificationsSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    postNotificaton: {
      prepare(
        prep: Omit<Notification, "id" | "dateCreated"> &
          Partial<Omit<Notification, "text" | "type">>
      ) {
        // console.log(prep);
        const { dateCreated, id, ...rest } = prep;
        return {
          payload: {
            id: id ?? uuid(),
            dateCreated: dateCreated ?? new Date().toISOString(),
            ...rest,
          },
        };
      },
      reducer(state, action: PayloadAction<Notification>) {
        notificationsAdapter.addOne(state, action.payload);
      },
    },
    removeNotification(state, action: PayloadAction<EntityId>) {
      notificationsAdapter.removeOne(state, action.payload);
    },
  },
});

export const notificationsSelectors = notificationsAdapter.getSelectors(
  (state: RootState) => state.notifications
);
export const notificationsActions = notificationsSlice.actions;
export const notificationsReducer = notificationsSlice.reducer;
